import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  stores: [],
  searchTerm: ''
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
